
import FulfillmentOptionLink from './FulfillmentOptionLink.vue';
import StockSubscriptionForm from './StockSubscriptionForm.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FulfillmentType } from '../../../types/ProductDelivery';
import { Get } from 'vuex-pathify';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { IProductDetailProductJson } from '../../../types/PDP';

@Component({
	name: 'FulfillmentOptionsStockInfo',
	components: {
		StockSubscriptionForm,
		FulfillmentOptionLink,
	}
})
export default class FulfillmentOptions extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly stockSubscriptionFormEnabled: boolean;

	/* Computed
	============================================*/

	@Get('product')
	readonly product: IProductDetailProductJson;

	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;

	@Get('isInStockForBopus')
	readonly isInStockForBopus: boolean;

	@Get('isInStockInStore')
	readonly isInStockInStore: boolean;

	@Get('customerEmail')
	readonly customerEmail: string | null;

	@Get('fulfillmentType')
	readonly fulfillmentType: FulfillmentType;

	get outOfMarket(): boolean {
		return !this.localStore;
	}

	get inStoreStockMessage(): string {
		if (this.product.notCarriedInStore) return 'Not Carried';
		if (this.isInStockForBopus) return this.product.activeInStorePickup ? 'In Stock' : 'Available in Store';
		if (this.isInStockInStore && this.product.storeNetOnHand < 10) return 'Limited Quantities in Store';
		if (this.isInStockInStore) return 'Available in Store';
		return 'Out of Stock';
	};

	/* Data
	============================================*/
	showChangeStore = false;
}
